
import React from 'react';
import { t } from '../i18n';



const PrivacyPolicyPage = () => (
  <div style={{ maxWidth: 800, margin: '40px auto', padding: 24, background: '#fff', borderRadius: 8, boxShadow: '0 2px 12px rgba(0,0,0,0.07)' }}>
    <h1>Politique de confidentialité</h1>
    <p><strong>Dernière mise à jour : 6 avril 2026</strong></p>
    <p>
      Nous attachons une importance particulière à la protection de vos données personnelles et au respect de votre vie privée. Cette politique explique quelles données nous collectons, comment elles sont utilisées et quels sont vos droits.
    </p>

    <h2>Données collectées</h2>
    <p>Nous collectons uniquement les données nécessaires au fonctionnement du service :</p>
    <ul>
      <li>Adresse e-mail (création de compte, newsletter)</li>
      <li>Contenus que vous publiez (textes, images, projets)</li>
      <li>Données techniques (pages consultées, interactions anonymisées)</li>
    </ul>
    <p>Aucune donnée sensible n’est collectée.</p>

    <h2>Utilisation des données</h2>
    <p>Vos données sont utilisées pour :</p>
    <ul>
      <li>Créer et gérer votre compte</li>
      <li>Publier et afficher vos contenus sur la plateforme</li>
      <li>Vous envoyer des communications si vous y avez consenti</li>
      <li>Améliorer le service et analyser l’utilisation (statistiques anonymes)</li>
    </ul>

    <h2>Contenus publiés (UGC)</h2>
    <p>Lorsque vous publiez un contenu (image, texte, projet) :</p>
    <ul>
      <li>Vous garantissez être titulaire des droits nécessaires ou disposer des autorisations requises</li>
      <li>Vous autorisez la plateforme à héberger, afficher, modifier et diffuser ce contenu, gratuitement et de manière non exclusive</li>
      <li>Votre contenu peut être visible publiquement et accessible à tous</li>
    </ul>
    <p>Nous nous réservons le droit de supprimer tout contenu illicite ou signalé.</p>

    <h2>Partage des données</h2>
    <p>
      Nous ne vendons ni ne partageons vos données personnelles avec des tiers.<br />
      Certaines données peuvent être traitées par des prestataires techniques (hébergement, analyse), uniquement dans l’Union européenne.
    </p>

    <h2>Durée de conservation</h2>
    <ul>
      <li>Compte utilisateur : conservé tant que le compte est actif</li>
      <li>Données associées : supprimées sur demande ou en cas de suppression du compte</li>
      <li>Données statistiques : anonymisées et conservées à des fins d’analyse</li>
    </ul>

    <h2>Cookies et mesure d’audience</h2>
    <p>
      Nous utilisons un outil de mesure d’audience respectueux de la vie privée, sans cookies et sans traçage individuel.<br />
      Aucune donnée personnelle n’est utilisée à des fins publicitaires.
    </p>

    <h2>Sécurité</h2>
    <p>
      Nous mettons en œuvre des mesures techniques et organisationnelles pour protéger vos données contre tout accès non autorisé.
    </p>

    <h2>Vos droits</h2>
    <p>Conformément au RGPD, vous disposez des droits suivants :</p>
    <ul>
      <li>Accès à vos données</li>
      <li>Rectification</li>
      <li>Suppression</li>
      <li>Limitation du traitement</li>
      <li>Portabilité</li>
    </ul>
    <p>Vous pouvez exercer ces droits en nous contactant.</p>

    <h2>Contact</h2>
    <p>
      Pour toute question relative à cette politique ou à vos données :<br />
      <a href="mailto:neurone1664@gmail.com">neurone1664@gmail.com</a>
    </p>

    <h2>Modification</h2>
    <p>
      Nous pouvons modifier cette politique à tout moment. La version en vigueur est celle publiée sur cette page.<br />
    </p>
  </div>
);

export default PrivacyPolicyPage;
